import { DialogsUtils } from "@/core/utils/layout/dialogs.utils";
import { MessagesUtils } from "@/core/utils/layout/messages.utils";
import { SessionService } from "@/core/services/security/session.service";
import { isGrupoAcessoElevado } from "@/core/utils/menu/grupo-acesso-elevado.util";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class ChangeTenantModalService {
    private dialogsUtils = inject(DialogsUtils);
    private sessionService = inject(SessionService);
    private messagesUtils = inject(MessagesUtils);
    private isModalOpen = false;

    canChangeTenant(): boolean {
        const user = this.sessionService.getInstance()?.user;
        if (!user) {
            return false;
        }
        if (isGrupoAcessoElevado(user.grupo)) {
            return true;
        }
        return (user.tenants?.length ?? 0) > 1;
    }

    usesElevatedTenantList(): boolean {
        return isGrupoAcessoElevado(this.sessionService.getInstance()?.user?.grupo);
    }

    async openChangeTenant(): Promise<void> {
        if (this.isModalOpen) {
            return;
        }

        if (!this.canChangeTenant()) {
            this.messagesUtils.showMessageErrorToast("components.changeTenantModal.accessDenied");
            return;
        }

        const session = this.sessionService.getInstance();
        if (!session?.isLogged || !session?.user?.username) {
            this.messagesUtils.showMessageErrorToast("messages.error.userNotAuthenticated");
            return;
        }

        try {
            this.isModalOpen = true;
            const { ChangeTenantModalComponent } = await import(
                "@/components/security/change-tenant-modal/change-tenant-modal.component"
            );
            const modal = await this.dialogsUtils.openDialogModal(
                ChangeTenantModalComponent,
                "components.changeTenantModal.title",
                "75%",
                null,
                "change-tenant-dialog",
            );
            await firstValueFrom(modal.onClose);
        } catch (error) {
            console.error("Erro ao abrir o modal de change tenant", error);
            this.messagesUtils.showMessageErrorToast("components.changeTenantModal.switchError");
        } finally {
            this.isModalOpen = false;
        }
    }
}
